/**
 * @author liqiuqi
 * @date 2022 2022/5/10 19:49
 */

import { deepClone } from "@/utils/common";
import { getAreaJson } from "@/assets/areaJSON";

/** 行业专区 **/
const industryZone = {
  namespaced: true,
  state: {
    isShowIndustryZone: false,
    industryZoneData: {
      backgroundImg: "", // done
      content: "", // done
      detailsLogo: "",
      id: 0, // done
      industryBusiness: [
        // {
        //   businessCode: "WY001005",
        //   businessId: 1,
        //   businessName: "综合管理",
        //   icon: "",
        //   sort: 1,
        // }
      ], // 所有分类
      industryData: {
        // tab 全部分类的数据，tab 其他分类的数据通过search接口抓取，存在了industryDataOtherTab里
        list: [
          // {
          //   area: null,
          //   businessName: null,
          //   contentId: 271440582,
          //   infoType: null,
          //   isCollect: null,
          //   publishTime: "2022-05-11",
          //   title: "珠海市斗门区井岸镇龙西小学<font color = 'red'><font color = 'red'><font color = 'red'>物业</font>管理</font>服务</font>定点议价采购公告"
          // }
        ],
        pageNo: 1,
        pageSize: 5,
        totalPage: 0,
        totalSize: 0,
      },
      industryName: "", // done
      logo: "", // done
      specialHeat: "", // done
      theme: null, // useless
      updateTodayCount: 0, // done
      weekTrend: "", // done
    },

    // tab 其他， list数据保存位置
    industryDataOtherTab: {
      list: [],
      pageNo: 1,
      pageSize: 5,
      totalPage: 0,
      totalSize: 0,
    },

    // 智能订阅
    isShowDialogSmartSubscribe: false,
    smartSubscribe: {
      businessCountData: [
        // {
        //   businessCode: "ZX002002",
        //   businessId: "6",
        //   businessName: "装修工程",
        //   count: 579,
        //   icon: "",
        // }
      ],
      detailsLogo: "",
      industryName: "",
      updateTodayCount: 0,
    },
    isShowBusinessAreaSelector: false,
    businessAreaSelected: deepClone(getAreaJson()), // 默认全国
    smartSubscribeId: 0, // 订阅成功返回的id
    isShowDialogSmartSubscribeSuccess: false, // 是否显示成功弹窗
    isShowDialogSmartSubscribeError: false, // 是否显示错误弹窗
    errorMessage: "", // 错误信息
  },
  getters: {
    isShowIndustryZone: (state) => state.isShowIndustryZone,
    industryZoneData: (state) => state.industryZoneData,
    industryDataOtherTab: (state) => state.industryDataOtherTab,
    isShowDialogSmartSubscribe: (state) => state.isShowDialogSmartSubscribe,
    smartSubscribe: (state) => state.smartSubscribe,
    isShowBusinessAreaSelector: (state) => state.isShowBusinessAreaSelector,
    businessAreaSelected: (state) => state.businessAreaSelected,
    smartSubscribeId: (state) => state.smartSubscribeId,
    isShowDialogSmartSubscribeSuccess: (state) => state.isShowDialogSmartSubscribeSuccess,
    isShowDialogSmartSubscribeError: (state) => state.isShowDialogSmartSubscribeError,
    errorMessage: (state) => state.errorMessage,
  },
  mutations: {
    updateIsShowIndustryZone(state, isShowIndustryZone) {
      state.isShowIndustryZone = isShowIndustryZone;
    },
    updateIndustryZoneData(state, industryZoneData) {
      state.industryZoneData = replaceRedToThemeColor(industryZoneData);
    },
    updateIndustryDataOtherTab(state, industryDataOtherTab) {
      state.industryDataOtherTab = replaceRedToThemeColor(industryDataOtherTab);
    },
    updateIsShowDialogSmartSubscribe(state, isShowDialogSmartSubscribe) {
      state.isShowDialogSmartSubscribe = isShowDialogSmartSubscribe;
    },
    updateSmartSubscribe(state, smartSubscribe) {
      state.smartSubscribe = smartSubscribe;
    },
    updateIsShowBusinessAreaSelector(state, isShowBusinessAreaSelector) {
      state.isShowBusinessAreaSelector = isShowBusinessAreaSelector;
    },
    updateSmartSubscribeId(state, smartSubscribeId) {
      state.smartSubscribeId = smartSubscribeId;
    },
    updateBusinessAreaSelected(state, businessAreaSelected) {
      state.businessAreaSelected = businessAreaSelected;
    },
    updateIsShowDialogSmartSubscribeSuccess(state, isShowDialogSmartSubscribeSuccess) {
      state.isShowDialogSmartSubscribeSuccess = isShowDialogSmartSubscribeSuccess;
    },
    updateIsShowDialogSmartSubscribeError(state, isShowDialogSmartSubscribeError) {
      state.isShowDialogSmartSubscribeError = isShowDialogSmartSubscribeError;
    },
    updateErrorMessage(state, errorMessage) {
      state.errorMessage = errorMessage;
    },
  },
  actions: {},
};

const replaceRedToThemeColor = (originData) => {
  const originDataStr = JSON.stringify(originData);
  const originDataStrFormat = originDataStr.replace(new RegExp("'red'", "g"), "'#ff952d'");
  return JSON.parse(originDataStrFormat);
};

export default industryZone;
